import CollapseAnimation from 'react-css-collapse'
import { useState } from 'react'
import { find } from 'lodash'

import Styles from './StyleSection.module.scss'
import { ArticleStyle } from 'types'
import { ArticleStyleProperty } from 'types'
import { Collapse } from 'common/Collapse/Collapse'
import { FontOptions, FontWeightOptions } from './constants'
import { ReactComponent as ChevronDown } from 'assets/icons/chevronDown16.svg'
import { ReactComponent as ChevronUp } from 'assets/icons/chevronUp16.svg'
import { StyleSectionForm } from './StyleSectionForm'

interface Props {
  defaults: Required<ArticleStyleProperty>
  name: keyof ArticleStyle
  property: ArticleStyleProperty
  setFieldValue: (name: keyof ArticleStyle, value: ArticleStyleProperty) => void
  title: string
}

const StyleSummary = ({ defaults, property }: Pick<Props, 'defaults' | 'property'>) => {
  return (
    <span className={Styles.styleSummary}>
      {find(FontOptions, { value: property.font_family || defaults.font_family })?.shortLabel}
      {' - '}
      {
        find(FontWeightOptions(property.font_family || defaults.font_family), {
          value: property.font_weight || defaults.font_weight,
        })?.label
      }
      {' - '}
      {property.font_size || defaults.font_size}
    </span>
  )
}

const mapLegacyFontWeight = (fontWeight?: string) => {
  if (!fontWeight) return fontWeight
  if (fontWeight === 'normal') return '400'
  if (fontWeight === 'bold') return '700'

  return fontWeight
}

export const StyleSection = ({ defaults, name, property, setFieldValue, title }: Props) => {
  const [collapsed, setCollapsed] = useState(true)

  property.font_weight = mapLegacyFontWeight(property.font_weight)

  return (
    <section className={Styles.section} title={title}>
      <header>
        <button className={Styles.titleButton} onClick={() => setCollapsed(!collapsed)} type="button">
          <span className={Styles.sectionTitle}>{title}</span>{' '}
          {collapsed && <StyleSummary defaults={defaults} property={property} />}
        </button>
        <Collapse
          collapsed={collapsed}
          collapseIconComponent={ChevronUp}
          expandIconComponent={ChevronDown}
          onToggle={(collapsed) => setCollapsed(collapsed)}
        />
      </header>
      <CollapseAnimation isOpen={!collapsed}>
        <StyleSectionForm defaults={defaults} name={name} property={property} setFieldValue={setFieldValue} />
      </CollapseAnimation>
    </section>
  )
}
